import React, { useState } from "react";
import { Progress } from "@chakra-ui/react";
import { useInterval } from "../../../../../hooks";

const Loading: React.FC = () => {
	const [loadingValue, setLoadingValue] = useState(0);

	useInterval(async (): Promise<void> => {
		setLoadingValue((prev) => (prev < 100 ? prev + 20 : 5));
	}, 1000);


	return (

		<Progress
			height="12px"
			hasStripe
			isAnimated
			value={loadingValue}
			colorScheme="purple"
		/>
	);

};

export default Loading;
